import { Empty } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";

import * as styles from "./MdmCardForm.module.less";
import { MdmCardFormStore } from "./MdmCardFormStore";

type PropsMdmCardForm = {
  store: MdmCardFormStore;
};

export const MdmCardForm: React.FC<PropsMdmCardForm> = observer((props) => {
  const { store } = props;
  return (
    <div className={styles.formBox}>
      {store.metaRoot ? store.metaRoot.render(store) : <Empty />}
    </div>
  );
});
